// extracted by mini-css-extract-plugin
module.exports = {"heroQuesWrapper":"HeroQuestion_heroQuesWrapper__zaSqj"};